import PageHeader from "../components/PageHeader";
import ContactInfo from '../components/Contact-info'

const Contactus = () => {

    return (
        <>
            <PageHeader pagetitle="Contact Us" breadcrumbMenu="Home" breadcrumbMenuActive="Contact Us" image="/images/contact-banner.png" />
            <ContactInfo />
        </>
    )
}

export default Contactus